export const JOURNAL_ENTRY_SUCEESS = "JOURNAL_ENTRY_SUCEESS";
export const JOURNAL_ENTRY_LOADING = "JOURNAL_ENTRY_LOADING";
export const JOURNAL_ENTRY_FAIL = "JOURNAL_ENTRY_FAIL";

export const ADD_JOURNAL_LOADING = "ADD_JOURNAL_LOADING";
export const ADD_JOURNAL_SUCCESS = "ADD_JOURNAL_SUCCESS";
export const ADD_JOURNAL_FAIL = "ADD_JOURNAL_FAIL";

export const DELETE_JOURNAL_LOADING = "DELETE_JOURNAL_LOADING";
export const DELETE_JOURNAL_SUCCESS = "DELETE_JOURNAL_SUCCESS";
export const DELETE_JOURNAL_FAIL =" DELETE_JOURNAL_FAIL";